import { ReactComponent as IconClose } from './close.svg'
import { ReactComponent as IconDelete } from './delete.svg'
import { ReactComponent as IconPlus } from './plus.svg'
import { ReactComponent as IconResetUserp } from './resetuserp.svg'

export const DEFAULT_ICON = {
    IconClose,
    IconDelete,
    IconPlus,
    IconResetUserp
}